export default {
  en: {
    title: "Profile Account",
    view_profile: "View Profile",
    edit_profile: "Edit Profile",
    reset_password: "Reset Password",
    personal_information: "Personal Information",
    additional_information: "Additional Information",
    full_name: "Full Name",
    email: "Email",
    mobile_number: "Mobile Number",
    join_date: "Join Date",
    group: "Group",
    update: "Update",
    clear: "Clear",
    cancel: "Cancel",
    reset: "Reset",
    user_id: "User ID",
    phone: "Phone",
    old_password: "Old Password",
    new_password: "New Password",
    confirm_password: "Confirm Password",
    error: "Error",
    close: "Close",
    updating_profile: "Updating profile....",
    resetting_password: "Reseting Password....",
    roles: {
      super_admin: "Super Admin",
      admin: "Admin",
      reporter: "Reporter",
      agent: "Agent",
    },
    errors: {
      password_required: "Password is required",
      password_characters_numbers: "Password must have characters and numbers",
      password_length: "Password must be 10 or more characters",
      fullname_required: "Full name is required",
      invalid_phone_number: "Invalid phone Number",
      phone_min_length: "Phone number minimum is 10 digits",
      phone_max_length: "Phone number maximum is 12 digits",
      invalid_email: "Email is not valid",
      passwords_not_matching: "Passwords are not matching",
    },
  },
  ar: {
    title: "الحساب الشخصي",
    view_profile: "عرض معلومات الحساب",
    edit_profile: "تعديل معلومات الحساب",
    reset_password: "إعادة تعيين كلمة المرور",
    personal_information: "معلومات شخصية",
    additional_information: "معلومات إضافية",
    full_name: "الاسم الكامل",
    email: "البريد إلكتروني",
    mobile_number: "رقم الهاتف المحمول",
    join_date: "تاريخ الانضمام",
    group: "المجموعة",
    update: "تحديث",
    clear: "مسح",
    cancel: "إلغاء",
    reset: "إعادة تعيين",
    user_id: "معرف المستخدم",
    phone: "هاتف",
    old_password: "كلمة المرور القديمة",
    new_password: "كلمة المرور الجديدة",
    confirm_password: "تأكيد كلمة المرور",
    error: "خطأ",
    close: "إغلاق",
    updating_profile: "جاري تحديث الملف الشخصي....",
    resetting_password: "جاري إعادة تعيين كلمة المرور....",
    roles: {
      super_admin: "مدير النظام",
      admin: "مدير",
      reporter: "مراقب",
      agent: "موظف",
    },
    errors: {
      password_required: "كلمة المرور مطلوبة",
      password_characters_numbers: "يجب أن تحتوي كلمة المرور على أحرف وأرقام",
      password_length: "يجب أن تكون كلمة المرور 10 أحرف أو أكثر",
      fullname_required: "الاسم الكامل مطلوب",
      invalid_phone_number: "رقم الهاتف غير صحيح",
      phone_min_length: "الحد الأدنى لعدد أرقام الهاتف هو 10",
      phone_max_length: "الحد الأقصى لعدد أرقام الهاتف هو 12",
      invalid_email: "البريد الإلكتروني غير صحيح",
      passwords_not_matching: "كلمات المرور غير متطابقة",
    },
  },
};
